import React from 'react';
import { generateBemCss } from 'general/js/helpers';
import { getHoleParBemClassForCustomEvent, getHoleParBemClassForCustomEventPointsBased } from '../../scores/js/score-themes';
import { hasValue } from '../../../general/js/general-helpers';

const CustomEventLeaderboardScoreCell = ({
    childCss, r2hAttributes, holePar, playerPar, status, isPointsBased
}) => {
    r2hAttributes = hasValue(r2hAttributes) ? r2hAttributes : {};

    const pointsBasedBem = isPointsBased ?
        getHoleParBemClassForCustomEventPointsBased(holePar, playerPar) :
        getHoleParBemClassForCustomEvent(holePar, playerPar);

    const bemCss = generateBemCss('score-cell', [pointsBasedBem, 'has-border']);

    let playerParText = playerPar;

    if (Number.isNaN(playerPar) || playerPar === null || playerPar === undefined || (!isPointsBased && playerPar === 0)) {
        playerParText = '-';
    }

    const statusClass = status ? 'live-player-scores__player-cell--has-status' : '';
    const cellClasses = `${childCss} ${bemCss} ${statusClass}`.trim();

    return (
        <div className={cellClasses} title={status} {...r2hAttributes}>{playerParText}</div>
    );
};

CustomEventLeaderboardScoreCell.defaultProps = {
    childCss: ''
};

export default CustomEventLeaderboardScoreCell;
